// extracted by mini-css-extract-plugin
module.exports = {"wordWrapper":"KeyWordButton_wordWrapper__Yhhfs","excluded":"KeyWordButton_excluded__3NvlJ","text":"KeyWordButton_text__1wgwY","button":"KeyWordButton_button__3WY7H"};